module.exports = __webpack_public_path__ + "static/img/5-z1.a6677b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/5-z1.png
// module id = 668
// module chunks = 140